<template>
  <v-dialog
    v-model="dialog"
    scrollable
    :overlay="false"
    min-width="500"
    max-width="800px"
    transition="dialog-transition"
  >
    <template v-slot:activator="{}">
      <!-- v-on="on" -->

      <v-btn
        small
        :loading="isloading"
        @click="OpenDialog"
        icon
        color="warning"
      >
        <v-icon>fas fa-info-circle</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title primary-title>
        {{ item.InvName }}
        <v-spacer></v-spacer>
        <v-btn icon color="primary" @click="dialog = false">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <!-- {{ item }} -->
        <base-table EmptyMessage="No Sales" :header="header" :items="list">
          <template #[`coll.QTY(OUT)`]="{ row }">
            {{ SellTypeQty(row) }}
          </template>
        </base-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    item: [Object],
  },
  components: {
    // OnTheWay: () => import("@/components/HQ/TheWay/items/BulkInventory"),
    // PrintView: () => import("@/components/Branches/Sales/printSaleReport.vue"),
  },
  // filters: {
  //   // SellTypeQty(row) {
  //   //   console.log(this);
  //   //   let qty = Math.abs(row.qty);
  //   //   const PCSQTY = (qty * this.item.UnitQty) % this.item.UnitQty;
  //   //   const BOXQTY = parseInt(qty);
  //   //   let FormatQTY = `0-${this.item.UnitType} `;
  //   //   if (BOXQTY > 0) FormatQTY = `${BOXQTY}-${this.item.UnitType} `;
  //   //   if (PCSQTY > 0) FormatQTY += `${PCSQTY}-PCS`;
  //   //   FormatQTY += ` =>(${qty * this.item.UnitQty} PCS)`;
  //   //   return FormatQTY;
  //   //   // if (row.SellType == "retail")
  //   //   //   return `${(Math.abs(row.qty) * this.item.UnitQty).toLocaleString()} PCS`;
  //   //   // return `${Math.abs(row.qty).toLocaleString()} ${this.item.UnitType}`;
  //   // },
  // },
  data() {
    return {
      SalesRepo: "/Reports/sales/itemSoldTrn",
      dialog: false,
      isloading: false,
      list: [],
      header: [
        { title: "Date", value: "date" },
        { title: "QTY(OUT)", value: "qty" },
        { title: "Sale Order", value: "Description" },
        { title: "User", value: "User" },
        // { title: "Price", value: "sellPrice" },
        // { title: "View", value: "view" },
      ],
    };
  },
  methods: {
    SellTypeQty(row) {
      // console.log(this);
      let qty = Math.abs(row.qty);
      const PCSQTY = (qty * this.item.UnitQty) % this.item.UnitQty;
      const BOXQTY = parseInt(qty);
      let FormatQTY = `0-${this.item.UnitType} `;
      if (BOXQTY > 0) FormatQTY = `${BOXQTY}-${this.item.UnitType} `;
      if (PCSQTY > 0) FormatQTY += `${PCSQTY}-PCS`;
      // FormatQTY += ` =>(${qty * this.item.UnitQty} PCS)`;
      return FormatQTY;
    },
    OpenDialog() {
      // this.dialog = true;
      this.isloading = true;
      this.GetReq()
        .then(val => {
          this.isloading = false;
          this.dialog = true;
          //   console.log(val);
          this.list = val.data;
        })
        .catch(err => {
          this.isloading = false;
          console.log(err);
        });
    },
    GetReq() {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: this.SalesRepo,
        query: {
          code: this.item.code,
          product: this.item.product,
        },
      });
    },
  },
};
</script>
